export enum InitialEmailLayoutType {
    NewMatches = 'new-match'
}